var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-filter-advanced-group',{attrs:{"title":"Designers","count":_vm.count}},[_c('core-filter-input-suggest',{attrs:{"placeholder":"Start typing a designer's name...","toggle":true,"field":"designer_name","filter":_vm.value('designers'),"api":"designers/suggest","data":"designers"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }